export const formatNumber = (value: number | string): string => {
  const num = Number(value);
  if (isNaN(num)) return '0.00';
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num);
};

// Non-breaking space between the currency symbol and the number so table
// cells never wrap the "$" onto its own line away from the amount.
export const formatMoney = (value: number | string): string => {
  const formatted = formatNumber(value);
  return `$\u00A0${formatted === '-0.00' ? '0.00' : formatted}`;
};
